import { useQueryClient } from '@tanstack/react-query';
import { useSaveDocumentMutation } from 'queries/pages';
import { useCallback } from 'react';
import { AutoSavePayload } from '../document-editor/extensions/auto-save/extension';

const DOCUMENT_QUERY_KEY = (id: number) => ['document', id] as const;

export const useAutoSaveDocument = (documentId: number) => {
  const queryClient = useQueryClient();
  const { mutateAsync: saveDocumentMutation } =
    useSaveDocumentMutation(documentId);

  const saveDocument = useCallback(
    (payload: AutoSavePayload) => {
      return saveDocumentMutation({
        tiptapJson: payload.json,
        htmlContent: payload.htmlContent,
      });
    },
    [saveDocumentMutation],
  );

  const refetchDocument = useCallback(() => {
    queryClient.refetchQueries({
      queryKey: DOCUMENT_QUERY_KEY(documentId),
    });
  }, [queryClient, documentId]);

  return {
    saveDocument,
    refetchDocument,
  };
};
